// Human labels for the current edition adoption stages, in the pattern of
// humanTaskStatus. The stored values are machinery. Members never see them.

export const ADOPTION_STATUS_LABEL: Record<string, string> = {
  eligible: "Ready to begin",
  initiated: "Getting started",
  generating: "Preparing your set",
  in_review: "With our team for a read through",
  ready_to_sign: "Ready for signatures",
  awaiting_signatures: "Waiting on signatures",
  paused: "On hold",
  complete: "Adopted",
  cancelled: "Stopped",
};

export function humanAdoptionStatus(status: string | null | undefined): string {
  if (!status) return "Ready to begin";
  return ADOPTION_STATUS_LABEL[status] ?? "In progress";
}

export const ADOPTION_SIGNER_LABEL: Record<string, string> = {
  pending: "Waiting to sign",
  signed: "Signed",
  declined: "Did not sign",
};

export function humanAdoptionSigner(status: string | null | undefined): string {
  if (!status) return "Waiting to sign";
  return ADOPTION_SIGNER_LABEL[status] ?? "Waiting to sign";
}

/** The five parts of the set, in the order they print. */
export const ADOPTION_PART_LABEL: Record<string, string> = {
  meeting_notice: "Notice of the meeting",
  meeting_minutes: "Minutes of the meeting",
  adoption_resolution: "Resolution adopting the current edition",
  restated_constitution: "The Constitution, current edition",
  acceptance_block: "Acceptance and signature pages",
};

export function humanAdoptionPart(part: string | null | undefined): string {
  if (!part) return "Document";
  return ADOPTION_PART_LABEL[part] ?? "Document";
}
